import React from "react"

import { FormControl, FormHelperText, FormLabel, Select, Option } from "@mui/joy";
import { Controller } from "react-hook-form";
import { Icon } from '../../assets';
import { useTranslation } from 'react-i18next';
import InputAutocomplete from "./InputAutocomplete";

const InputAutocompleteControl = ({ editing, required, name, control, label, autoFocus, placeholder, type = "select", hint, icon, disabled, readonly, addEmptyOption = false, haserror, options = [], translateOptions = true, className = "",
    dataProvider, searchkey = "name", searchkeys = [], labelkey = "label", filters = {}, project = [], multiple = false, keyvalue
}) => {
    const { t } = useTranslation();

    if (!editing) readonly = true;
    if (readonly) disabled = true;


    const generateOptions = () => {
        return options.map((option, k) => (
            <Option key={k} value={option.value}>{translateOptions ? t(option.label) : option.label}</Option>
        ));
    };

    return (

        <Controller
            name={name}
            control={control}
            render={({
                field: { onChange, value, name },
                fieldState: { error, invalid },
                formState,
            }) => {
                let generalClass = "form-element-control";
                generalClass += (editing) ? " editing" : " reading";
                generalClass += (invalid) ? " error" : "";
                generalClass += (required) ? " required" : "";
                generalClass += (disabled) ? " disabled" : "";
                generalClass += (readonly) ? " readonly" : "";

                if (typeof value == typeof undefined) {
                    className = className.replace(' filled', '').replace(' empty', '') + ' empty';
                } else {
                    className = className.replace(' filled', '').replace(' empty', '') + ' filled';
                }

                return (
                    <div className={("form-element autocomplete " + className).trim()}>
                        <FormControl error={invalid} className={(error) ? generalClass + " form-element-error" : generalClass}>
                            <FormLabel className="form-element-label" htmlFor={name}>{t(label)}</FormLabel>
                            <InputAutocomplete
                                id={name}
                                type={type}
                                name={name}
                                value={value}
                                error={invalid}
                                onChange={onChange}
                                variant="outlined"
                                className="form-element-field form-element-field-autocomplete"

                                autoFocus={autoFocus}
                                placeholder={t(placeholder)}
                                disabled={disabled}
                                readonly={readonly}
                                required={required}
                                multiple={multiple}

                                startDecorator={(icon) ? (
                                    <Icon icon={icon} />
                                ) : (
                                    <></>
                                )}
                                endDecorator={(haserror || error) ? (
                                    <Icon icon="faCircleExclamation" />
                                ) : (
                                    <></>
                                )}

                                //
                                dataProvider={dataProvider}
                                searchkey={searchkey}
                                searchkeys={searchkeys}
                                labelkey={labelkey}
                                filters={filters}
                                project={project}
                                keyvalue={keyvalue}
                            />
                            <FormHelperText className="form-element-hint">
                                {(haserror || error) ? (
                                    <>
                                        {error ? error.message : 'Messaggio di errore'}
                                    </>
                                ) : (
                                    <>
                                        {hint}
                                    </>
                                )}
                            </FormHelperText>
                        </FormControl>
                    </div>
                )
            }}
        />

    );
};


export default InputAutocompleteControl;
